import React from 'react'
import './style.scss'

export function BaseCard({ icon, text, onClick, isDisabled = false, tag }) {
  function handleClick() {
    if (onClick) onClick()
  }

  function renderTag() {
    if (!tag) return null

    const { TEXT, STYLE } = tag

    return <div className={`container-tag ${STYLE}`}>{TEXT}</div>
  }

  return (
    <button
      disabled={isDisabled}
      type='button'
      onClick={handleClick}
      className='container-base-card'
    >
      {renderTag()}
      <div className='container-icon'>{icon}</div>
      <div className='container-text'>
        <span className='text'>{text}</span>
      </div>
    </button>
  )
}
